import { http } from './fetch-wrapper';
import { apiUrls } from './index';

export function resetPost(params) {
  const headers = new Headers();

  headers.append('Content-Type', 'application/json ');

  const requestOptions = { method: 'POST', headers, body: JSON.stringify(params) };

  return http(apiUrls.SECURITY_RESET, requestOptions);
}

export function resetPut(params) {
  const headers = new Headers();

  headers.append('Content-Type', 'application/json ');

  const requestOptions = { method: 'PUT', headers, body: JSON.stringify(params) };

  return http(apiUrls.SECURITY_RESET, requestOptions);
}



// WEBPACK FOOTER //
// ./api/security.js